import { useState } from 'react';
import type { LucideIcon } from 'lucide-react';
import { ImageOff } from 'lucide-react';

type SafeImageProps = {
  src?: string | null;
  alt: string;
  className?: string;
  icon?: LucideIcon;
  iconClassName?: string;
  wrapperClassName?: string;
};

/**
 * Renders an image when a valid src is provided; otherwise shows a fallback icon.
 * Treats the Vite placeholder (`/vite.svg`) as missing content.
 */
export const SafeImage = ({
  src,
  alt,
  className,
  icon: Icon = ImageOff,
  iconClassName = 'h-10 w-10 text-slate-400',
  wrapperClassName = '',
}: SafeImageProps) => {
  const [failed, setFailed] = useState(false);
  const shouldShowIcon = !src || src === '/vite.svg' || failed;

  if (shouldShowIcon) {
    return (
      <div className={`flex items-center justify-center bg-slate-100 ${className ?? ''} ${wrapperClassName}`}>
        <Icon aria-label={alt} className={iconClassName} />
      </div>
    );
  }

  return <img src={src} alt={alt} className={className} onError={() => setFailed(true)} />;
};

export default SafeImage;
